import { EntityTypes } from './types'

export const FIND_PATTERN = /CHAT_ID|BOT_ID|CHANNEL_ID|USER_ID/ig

export const ENTITY_PARAM_KEYS = [
  EntityTypes.USER_ID,
  EntityTypes.BOT_ID,
  EntityTypes.CHANNEL_ID,
  EntityTypes.CHAT_ID,
]
